module.exports = __webpack_public_path__ + "static/media/spider-web.59aa6249.svg";